/**
 * Updated Aug 22, 2024 to match backend - https://github.com/KeyLiving/services/blob/master/services/api-service/src/constants/invoice.ts
 */

export enum RESIDENCY_PAYMENT {
    CARRYING_COST = 'CARRYING_COST',
    CO_FINANCING_INTEREST = 'CO_FINANCING_INTEREST',
    CONDO_FEES = 'CONDO_FEES',
    HAAS_FEE = 'HAAS_FEE',
    OCCUPANCY_PAYMENT = 'OCCUPANCY_PAYMENT',
    OWNERSHIP_SAVINGS = 'OWNERSHIP_SAVINGS',
    RENT = 'RENT',
    RENT_EQUIVALENT = 'RENT_EQUIVALENT',
    SUITE_EXPENSES = 'SUITE_EXPENSES',
}

export enum RECURRING_SERVICES {
    HOME_ONBOARDING_FEE = 'HOME_ONBOARDING_FEE',
    HYDRO = 'HYDRO',
    LOCKER = 'LOCKER',
    PARKING = 'PARKING',
    REPAIR_AND_MAINTENANCE = 'REPAIR_AND_MAINTENANCE',
    RESIDENT_INSURANCE = 'RESIDENT_INSURANCE',
    RESIDENT_SOURCING_FEE = 'RESIDENT_SOURCING_FEE',
    WATER = 'WATER',
}

export enum EQUITY_TRANSACTIONS {
    AUTO_EQUITY_PURCHASE = 'AUTO_EQUITY_PURCHASE',
    BETA_EQUITY_BOOST_CREDIT = 'BETA_EQUITY_BOOST_CREDIT',
    EQUITY_ADMIN_FEE = 'EQUITY_ADMIN_FEE',
    EQUITY_BOOST = 'EQUITY_BOOST',
    EQUITY_PURCHASE = 'EQUITY_PURCHASE',
    EQUITY_REDEMPTION = 'EQUITY_REDEMPTION',
    INITIAL_INVESTMENT = 'INITIAL_INVESTMENT',
    OWNERSHIP_SAVINGS_REINVESTMENT = 'OWNERSHIP_SAVINGS_REINVESTMENT',
}

export enum ADDITIONAL_CHARGES_OR_CREDITS {
    ADJUSTMENT_GENERAL = 'ADJUSTMENT_GENERAL',
    ADJUSTMENT_RENT = 'ADJUSTMENT_RENT',
    ADJUSTMENT_SERVICES = 'ADJUSTMENT_SERVICES',
    INSPECTION_FEE = 'INSPECTION_FEE',
    MOVING_SERVICES = 'MOVING_SERVICES',
    RESIDENT_ONBOARDING_FEE = 'RESIDENT_ONBOARDING_FEE',
    WEAR_AND_TEAR_CHARGE = 'WEAR_AND_TEAR_CHARGE',
}

export const INVOICE_SECTIONS = [
    { header: 'Residency Payment', items: RESIDENCY_PAYMENT },
    { header: 'Recurring Services', items: RECURRING_SERVICES },
    { header: 'Equity Transactions', items: EQUITY_TRANSACTIONS },
    { header: 'Additional Charges Or Credits', items: ADDITIONAL_CHARGES_OR_CREDITS },
];
